module.exports = __webpack_public_path__ + "static/media/panco_03.d79e7f45.jpg";